import React from 'react';
import loadable from '@loadable/component';
import { Helpers } from '../../../core/src/helpers';

const CompareView = loadable(() => Helpers.retryFunc(() => import('./compare-view')));

export default props => {
    return <CompareView {...props} />;
};
